@if (open) {
  <div
    class="home-cuenta-politicas"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="'home-cuenta-politicas-title'"
    (click)="salir()"
  >
    <div
      class="home-cuenta-politicas__dialog"
      (click)="$event.stopPropagation()"
    >
      <header class="home-cuenta-politicas__header">
        <h2 id="home-cuenta-politicas-title" class="home-cuenta-politicas__title">
          {{ title }}
        </h2>
      </header>

      <div
        #bodyEl
        class="home-cuenta-politicas__body"
        (scroll)="onBodyScroll()"
      >
        @if (tipo === 'P') {
          <div class="home-cuenta-politicas__content">
            <p>
              De conformidad con lo establecido en las normas que regulan el derecho a la
              protección de datos personales en Colombia y la Política de Tratamiento de Datos
              Personales del Banco de Comercio Exterior de Colombia S.A. que puede ser consultada
              en:
            </p>
            <p>
              <a
                class="home-cuenta-politicas__link"
                href="https://www.bancoldex.com/es/politica_tratamientos_datos_bx"
                (click)="openLink('https://www.bancoldex.com/es/politica_tratamientos_datos_bx', $event)"
              >
                https://www.bancoldex.com/es/politica_tratamientos_datos_bx
              </a>
            </p>
            <p>
              Autorizo de manera previa, expresa e informada a Bancóldex para consultar, recolectar,
              almacenar, usar, circular, compartir, transmitir o suprimir mis datos personales y
              financieros, para:
            </p>
            <ol class="home-cuenta-politicas__list" type="I">
              <li>
                Acceder a los servicios de neocrédito y, particularmente, para transferirla al
                Aliado<sup id="ref_p"><a href="#nota_p" (click)="scrollToAnchor('nota_p', $event)">1</a></sup> con el objeto de que éste
                analice la información entregada, para decidir o no presentar una Oferta de Crédito.
              </li>
              <li>
                Compartirla con entidades o programas del gobierno colombiano con los cuales
                Bancóldex tenga una relación contractual y que sea entregada para el desarrollo de
                actividades correspondientes al cumplimiento de su objeto.
              </li>
              <li>
                Enviarme información y ser contactado directamente por Bancóldex, por sus Aliados o
                por las entidades o programas del gobierno.
              </li>
              <li>
                Poner a disposición de las autoridades competentes la información requerida por estas.
              </li>
            </ol>
            <p>
              En caso de aceptación de una Oferta de Crédito, el Aliado será responsable del
              tratamiento de mis datos personales y financieros.
            </p>
            <p>
              La presente autorización la otorgo hasta el momento en el que exprese a Bancóldex su
              revocatoria, por cualquiera de los canales dispuestos para tal fin.
            </p>
            <p>
              Declaro haber leído y entendido y autorizo a Bancóldex el Tratamiento de Datos
              Personales.
            </p>
            <hr class="home-cuenta-politicas__hr" />
            <ol class="home-cuenta-politicas__notes">
              <li id="nota_p">
                <a href="#ref_p" (click)="scrollToAnchor('ref_p', $event)">↑</a>
                La lista actualizada de Aliados puede ser consultada en:
                <a
                  class="home-cuenta-politicas__link"
                  href="https://neocredito.bancoldex.com/neocredito/home"
                  (click)="openLink('https://neocredito.bancoldex.com/neocredito/home', $event)"
                >
                  https://neocredito.bancoldex.com/neocredito/home
                </a>
              </li>
            </ol>
          </div>
        }

        @if (tipo === 'T') {
          <div class="home-cuenta-politicas__content">
            <p>
              Lo invitamos a leer estos Términos y Condiciones y aceptarlos antes de iniciar la
              exploración o uso del Sitio Web.
            </p>
            <p class="home-cuenta-politicas__subtitle"><strong>Definiciones</strong></p>
            <p>
              Por favor tener en cuenta las siguientes definiciones de algunos términos usados
              reiterativamente en el documento:
            </p>
            <p>
              Bancóldex: es el Banco de Comercio Exterior de Colombia S.A. identificado con NIT
              800.149.923-6.
            </p>
            <p>
              Contrato para Vinculación neocrédito: es el contrato suscrito entre Bancóldex y las
              entidades financieras vigiladas por la Superintendencia Financiera, las entidades
              orientadas al crédito microempresarial y las fintech que se encuentren registradas en
              el Sitio Web y que tiene por objeto definir los términos y condiciones que deben ser
              cumplidos por el Aliado para la vinculación y uso del Sitio Web, así como los derechos
              y obligaciones de las partes.
            </p>
            <p>
              Aliado(s): son las entidades que tengan suscrito con Bancóldex el Contrato Marco para
              la Utilización de Líneas de Crédito y Servicios Financieros Ofrecidos por Bancóldex, el
              Contrato para la vinculación a neocrédito y, que se encuentren registradas en el Sitio
              Web.
            </p>
            <p>
              Microempresario: son las personas naturales o jurídicas que se registran en el Sitio Web
              a fin de acceder a los servicios que ofrece neocrédito.
            </p>
            <p>
              neocrédito: es una plataforma digital desarrollada por Bancóldex y alojada en un sitio
              web, que permite la interacción entre oferentes y demandantes de crédito. Las
              operaciones de crédito que resulten de esta interacción se formalizarán fuera de la
              plataforma, es decir, de manera directa entre Aliados y Microempresarios.
            </p>
            <p>
              Oferta de Crédito: es el crédito aprobado por el Aliado al Microempresario, el cual no
              podrá ser revocado sin justa causa, una vez aceptado por el Microempresario a través de
              neocrédito.
            </p>
            <p>
              Sitio Web:
              <a
                class="home-cuenta-politicas__link"
                href="https://neocredito.bancoldex.com/neocredito"
                (click)="openLink('https://neocredito.bancoldex.com/neocredito', $event)"
              >
                www.neocredito.bancoldex.com
              </a>
            </p>
            <p>
              Solicitud de Crédito: es la solicitud de crédito que hacen los Microempresarios a
              través de neocrédito.
            </p>

            <p class="home-cuenta-politicas__subtitle"><strong>Funcionamiento de neocrédito</strong></p>
            <p>
              Previa autorización para el tratamiento de datos otorgada por el Microempresario en el
              Sitio Web, la información cargada por el Microempresario en el Sitio Web es compartida
              por Bancóldex con los Aliados, quienes la analizan y, a partir de ello, hacen una Oferta
              de Crédito al Microempresario.
            </p>
            <p>
              El uso del Sitio Web proporcionado por Bancóldex no garantiza al Microempresario la
              aprobación del crédito solicitado, ni al Aliado que el Microempresario tome el crédito
              aprobado. En este sentido, la obligación de Bancóldex es de medio y no de resultado.
            </p>

            <p class="home-cuenta-politicas__subtitle"><strong>Disponibilidad del servicio</strong></p>
            <p>
              El acceso al Sitio Web permanentemente estará disponible para el Microempresario salvo
              que existan circunstancias de fuerza mayor, caso fortuito o hechos de un tercero que
              impidan o restrinjan dicho acceso.
            </p>
            <p>
              Bancóldex se reserva el derecho de modificar o suprimir los contenidos del Sitio Web sin
              necesidad de previo aviso. En todo caso, las modificaciones, actualizaciones o
              eliminaciones, serán informadas a través del mismo medio con el fin de que los
              Microempresarios estén plenamente informados de los cambios realizados.
            </p>

            <p class="home-cuenta-politicas__subtitle">
              <strong>Vínculos con otros sitios en Internet</strong>
            </p>
            <p>
              Bancóldex facilita a los Microempresarios la posibilidad de escoger una Oferta de
              Crédito entre las ofertas entregadas por los Aliados.
            </p>
            <p>
              Aceptada una Oferta de Crédito por el Microempresario, el proceso de formalización y
              desembolso deberá realizarse directamente a través de los canales que el Aliado tenga
              habilitados para ello dentro de los cuales se incluye su propio sitio web, líneas
              telefónicas, oficinas o cualquier otro canal dispuesto por el Aliado.
            </p>
            <p>
              Bancóldex pone a disposición el Sitio Web para que el Microempresario elija el crédito
              que mejor se acomode a sus necesidades. Atendiendo esto, Bancóldex no asume
              responsabilidad en caso de que el Microempresario no reciba ofertas de crédito.
            </p>
            <p>
              Cualquier transacción que el Microempresario lleve a cabo con los Aliados se realiza
              única y exclusivamente entre el Microempresario y el Aliado, bajo su propia
              responsabilidad. Los sitios vinculados al Sitio Web no son controlados por Bancóldex,
              razón por la cual, este no es responsable de estos sitios.
            </p>
            <p>
              El Microempresario entiende y acepta que, a partir de la aceptación de la Oferta de
              Crédito, debe cumplir con todas las políticas y procedimientos para el otorgamiento de
              crédito definidos por el Aliado.
            </p>

            <p class="home-cuenta-politicas__subtitle"><strong>Derecho de propiedad</strong></p>
            <p>
              El Sitio Web está protegido por derechos de autor, marcas, patentes, o formas
              diferentes del derecho de propiedad. Dicho contenido incluye, entre otros, los textos,
              el software, la música, el sonido, las fotografías, los videos, los gráficos, etc. Por
              lo tanto, el Microempresario deberá abstenerse de publicar, retransmitir o comercializar
              a cualquier título o por cualquier medio, total o parcialmente, tanto la información
              contenida en el Sitio Web, como en sus enlaces, so pena de incurrir en las
              responsabilidades por violación de los derechos de autor, conforme a las normas
              vigentes.
            </p>

            <p class="home-cuenta-politicas__subtitle">
              <strong>Características del equipo para la óptima navegación</strong>
            </p>
            <p>
              Para asegurar una correcta visualización de nuestro Sitio Web se recomienda utilizar los
              navegadores Microsoft Edge 91, Firefox 90, Chrome 92 o superior.
            </p>

            <p class="home-cuenta-politicas__subtitle"><strong>Seguridad</strong></p>
            <p>
              El Sitio Web cuenta con los procedimientos electrónicos para proteger y ayudar a
              prevenir el acceso no autorizado, evitar la pérdida, mal uso, alteración, acceso no
              autorizado y hurto de los datos personales.
            </p>
            <p>
              El Microempresario será responsable de los daños y perjuicios que pueda causar a
              Bancóldex o a cualquier tercero por los usos indebidos del Sitio Web.
            </p>
            <p>
              De acuerdo con lo informado previamente, el Microempresario autoriza y declara lo
              siguiente:
            </p>

            <p class="home-cuenta-politicas__subtitle"><strong>Declaraciones:</strong></p>
            <p>El Microempresario declara que:</p>
            <ol class="home-cuenta-politicas__list">
              <li>Bancóldex es propietario del Sitio Web.</li>
              <li>Conoce la mecánica de operación de neocrédito.</li>
              <li>
                Conoce y acepta que Bancóldex no es la entidad que evalúa y aprueba las operaciones de
                crédito y que, en caso de ser aprobada una Oferta de Crédito, la formalización de la
                operación se hará directamente con el Aliado.
              </li>
              <li>
                La información cargada al Sitio Web es completa, cierta, verificable y no contiene
                falsedades. En caso de que Bancóldex conozca de la posible comisión de algún delito
                haciendo uso de su Sitio Web, de tal situación pondrá en conocimiento a las
                autoridades.
              </li>
              <li>
                Conoce y acepta que el sitio puede presentar indisponibilidades temporales no
                imputables a Bancóldex.
              </li>
              <li>
                Conoce que el Sitio Web no ofrece transaccionalidad de ninguna clase y en el mismo no
                se realiza transferencias de recursos.
              </li>
              <li>
                Se hace responsable del manejo de los Microempresarios y contraseñas que le sean
                autorizados para el acceso y gestión en el Sitio Web.
              </li>
              <li>
                Conoce que los plazos incluidos en las diferentes etapas del proceso de neocrédito son
                indicativos, por lo que en caso de no cumplirse alguno, tal situación no implica
                ningún tipo de responsabilidad para Bancóldex.
              </li>
              <li>
                Mantendrá la confidencialidad de la información a la que acceda con ocasión del uso
                del Sitio Web.
              </li>
              <li>
                Conoce que en caso de aceptar una Oferta de Crédito de un Aliado no vigilado por la
                Superintendencia Financiera, no tendrán aplicación las normas sobre consumidor
                financiero.
              </li>
              <li>
                El origen y destino de sus recursos es lícito y no contraviene el ordenamiento
                jurídico colombiano.
              </li>
              <li>
                No se encuentra reportado en ninguna de las listas internacionales vinculantes para
                Colombia en temas de lavado de activos, financiación del terrorismo y/o proliferación
                de armas de destrucción masiva, y así mismo no se encuentra condenado por la comisión
                de actividades involucradas con los anteriores delitos.
              </li>
              <li>
                En caso de incumplimiento de las declaraciones 11 y 12, no podrá continuar utilizando
                neocrédito.
              </li>
            </ol>

            <p class="home-cuenta-politicas__subtitle">
              <strong>Ley y Jurisdicción aplicables</strong>
            </p>
            <p>
              Las políticas y condiciones de acceso y uso aquí establecidas y los conflictos que
              puedan surgir respecto de su interpretación, uso, alcance y terminación se rigen por la
              ley Colombiana y se someten a los jueces y tribunales colombianos.
            </p>
            <ul class="home-cuenta-politicas__list home-cuenta-politicas__list--bullets">
              <li>
                Declaro haber leído entendido los Términos y Condiciones para el uso del Sitio Web y
                de neocrédito, por lo que los acepto.
              </li>
            </ul>
          </div>
        }
      </div>

      <footer class="home-cuenta-politicas__footer">
        <button type="button" class="home-cuenta-politicas__btn-salir" (click)="salir()">
          Salir
        </button>
        <button
          type="button"
          class="home-cuenta-politicas__btn-aceptar"
          [disabled]="!acceptEnabled"
          (click)="aceptar()"
        >
          Aceptar
        </button>
      </footer>
    </div>
  </div>
}
